/** @jsx jsx */

import { jsx, css } from '@emotion/core';

import { Button, Heading, Text, Spacer } from '@zapier/design-system';
import { FlexLayout, Modal } from '@zapier/common-components';
import { addParamsToUrl } from '@zapier/url-utils';

import { Confetti } from '@zapier/design-system-revenue/src/components/private';

const containerStyles = css`
  text-align: center;
`;

type Props = {
  /** The new account ID */
  accountId: number;
};

export const SuccessModal = ({ accountId }: Props) => {
  return (
    <Modal
      ariaDescribedBy="modal-description"
      ariaLabelledBy="modal-title"
      closeOnOutsideClick={false}
      overflowY="hidden" // ensures confetti doesn't make the modal scrollable
    >
      <div css={containerStyles}>
        <Confetti />
        <Heading>
          <Text type="header800">
            <span id="modal-title">Success!</span>
          </Text>
        </Heading>

        <Spacer height={20} />
        <Text type="bodyText900">
          <span id="modal-description">Thanks for creating a new account.</span>
        </Text>
        <Spacer height={30} />

        <FlexLayout direction="row" gutter="normal" justify="center">
          <Button
            href={addParamsToUrl('/app/settings', { context: accountId })}
          >
            Set up account
          </Button>
        </FlexLayout>
      </div>
    </Modal>
  );
};
